import React,{useState,useEffect} from 'react';
import { string, bool } from 'prop-types';
import { styWrapperItem, styWithAnimation } from './styles';
import default_image from './assets/male.png';
import PropTypes from 'prop-types';
function WishesItem({ imagen_invitado, nombre, informacion, mensaje, isActive }) {
  const [imageUrl, setImageUrl] = useState();
  useEffect(() => {
    // Convertir los bytes de la imagen en un objeto Blob
    if(imagen_invitado){

      const blob = new Blob([new Uint8Array(imagen_invitado.data)], {
        type: "image/jpeg",
      });
      
      // Crear una URL a partir del objeto Blob
      const url = URL.createObjectURL(blob);
      
      // Actualizar el estado con la URL generada
      setImageUrl(url);
      // Limpieza: remover la URL cuando el componente se desmonte
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [imagen_invitado]);
  
  if (!isActive) return null;
  const renderItem = () => {
    return (
      <div className="item" css={styWrapperItem}>
        <div className={`testimony-slide text-center ${isActive ? 'active' : 'hide'}`}>
          {imagen_invitado === null ? (
             <figure>
              <img src={default_image} alt="user" loading="lazy" />
            </figure>
          ) : (
            <figure>
              <img src={imageUrl} alt="user" loading="lazy" />
            </figure>
          )}
          <h4>{nombre}</h4>
          <span className="infoName">{informacion}</span>
          <blockquote>
            <p className="description">{mensaje}</p>
          </blockquote>
        </div>
      </div>
    );
  };

  return <div css={styWithAnimation(isActive)}>{renderItem()}</div>;
}

WishesItem.propTypes = {
  imagen_invitado: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  nombre: string.isRequired,
  informacion: string.isRequired,
  mensaje: string.isRequired,
  isActive: bool.isRequired,
};

export default React.memo(WishesItem);
